import {
  IconButton,
  Pagination,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Tab,
  Box,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import SvgIcon from "../../components/Images/SvgIcon";
import moment from "moment";
import {
  startLoader,
  stopLoader,
  showToast,
  open_dialog,
} from "../../lib/global";
import { DELETE_AD_MODEL } from "../../lib/constant";
import { breadcrumbAction } from "../../redux/actions/config.action";
import { getAllAds, updateAdById } from "../../redux/actions/ads.action";
import Image from "../../components/Images/Image";
import ablity from "../../helpers/abilityGuard";
import { IOSSwitch } from "../../components/switch/IOSSwitch";

const placements = [
  {
    value: "top-header",
    label: "Top Header",
    description: "Full-width strip banner at page top",
    size: "Strip: 1920 x 70 px | Expanded: 1200 x 655 px",
  },
  {
    value: "top-right",
    label: "Top Right",
    description: "Small ad widget near search bar",
    size: "320 x 72 px",
  },
  {
    value: "deals-promotion",
    label: "Deals Promotion",
    description: "Deal banners in deals section",
    size: "416 x 216 px",
  },
  {
    value: "promo-banner",
    label: "Promo Banner",
    description: "Full-width promo image",
    size: "1180 x 250 px",
  },
];

function AdsAndBanner() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [activeTab, setActiveTab] = useState("top-header");
  const [adsData, setAdsData] = useState([]);
  const [offset, setOffset] = useState(0);
  const [limit] = useState(10);

  const fetchAds = () => {
    startLoader();
    dispatch(getAllAds({ placement: activeTab, limit, offset }))
      .then((res) => {
        if (res && res.data && res.data.status === 200) {
          setAdsData(res.data.data || []);
        } else {
          setAdsData([]);
        }
        setTimeout(() => stopLoader(), 500);
      })
      .catch((err) => {
        console.error("Error fetching ads:", err);
        setAdsData([]);
        stopLoader();
      });
  };

  useEffect(() => {
    const breadcrumb = [{ label: "Ads and Banner", url: null }];
    dispatch(breadcrumbAction(breadcrumb));
  }, [dispatch]);

  useEffect(() => {
    fetchAds();
  }, [activeTab, offset]);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    setOffset(0);
  };

  const handlePageChange = (event, value) => {
    setOffset(value - 1);
  };

  const handleStatusToggle = (id, currentStatus) => {
    startLoader();
    dispatch(updateAdById(id, { isActive: !currentStatus }))
      .then((res) => {
        stopLoader();
        showToast("Status updated successfully", "success");
        fetchAds();
      })
      .catch((err) => {
        stopLoader();
        console.error("Error updating status:", err);
        showToast("Failed to update status", "error");
      });
  };

  const handleDeleteClick = (id) => {
    open_dialog(DELETE_AD_MODEL, {
      onSubmit: fetchAds,
      id,
    });
  };

  const currentPlacement = placements.find((p) => p.value === activeTab);

  return (
    <React.Fragment>
      <div className="card mx-3 p-3 shadow-sm border-0">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h5 className="font-weight-bold mb-1">ADS & BANNER MANAGEMENT</h5>
            <p className="text-muted mb-0 small">
              Manage website advertising banners and placements.
            </p>
          </div>
          <div>
            {ablity({ model: "Ads", action: "create" }) === 1 && (
              <button
                type="button"
                onClick={() => history.push("/ads-and-banner/add")}
                className="btn btn-dark px-4 py-2 text-nowrap rounded-lg shadow-sm"
              >
                + Add Ad Banner
              </button>
            )}
          </div>
        </div>

        {/* Dynamic Placements Tab View */}
        <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            textColor="primary"
            indicatorColor="primary"
          >
            {placements.map((tab) => (
              <Tab key={tab.value} label={tab.label} value={tab.value} />
            ))}
          </Tabs>
        </Box>

        {/* Info Box about selected placement */}
        {currentPlacement && (
          <div className="alert alert-light border d-flex justify-content-between align-items-center mb-4 p-3 rounded-lg">
            <div>
              <span className="badge text-uppercase mb-1 px-2 py-1" style={{ backgroundColor: "#495057", color: "#ffffff" }}>
                {currentPlacement.value}
              </span>
              <div className="font-weight-bold text-dark mt-1">
                {currentPlacement.description}
              </div>
            </div>
            <div className="text-right">
              <div className="small text-muted font-weight-bold">Expected Image Size</div>
              <div className="text-primary font-weight-bold h6 mb-0">
                {currentPlacement.size}
              </div>
            </div>
          </div>
        )}

        <TableContainer className="border rounded-lg">
          <Table sx={{ minWidth: 650 }} stickyHeader aria-label="sticky table">
            <TableHead className="bg-light">
              <TableRow>
                <TableCell className="th_cell font-weight-bold" align="left" style={{ width: "60px" }}>
                  No.
                </TableCell>
                <TableCell className="th_cell font-weight-bold" align="left">
                  Image Preview
                </TableCell>
                <TableCell className="th_cell font-weight-bold" align="left">
                  Alt Text
                </TableCell>
                <TableCell className="th_cell font-weight-bold" align="left">
                  Target Link
                </TableCell>
                <TableCell className="th_cell font-weight-bold" align="center">
                  Schedule Period
                </TableCell>
                <TableCell className="th_cell font-weight-bold" align="center" style={{ width: "100px" }}>
                  Active
                </TableCell>
                <TableCell className="th_cell font-weight-bold text-center" align="center" style={{ width: "120px" }}>
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {adsData.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={7} align="center" className="py-5 text-muted">
                    <h5>No advertisements found for this placement</h5>
                    <p className="mb-0 text-secondary">Click the "+ Add Ad Banner" button to create one.</p>
                  </TableCell>
                </TableRow>
              ) : (
                adsData.map((row, i) => (
                  <TableRow key={row.id || i} hover>
                    <TableCell align="left" className="td_cell align-middle">
                      {offset * limit + (i + 1)}
                    </TableCell>
                    <TableCell align="left" className="td_cell align-middle">
                      {activeTab === "top-header" ? (
                        <div className="d-flex flex-column gap-2 py-1">
                          <div className="d-flex align-items-center">
                            <span className="badge bg-light text-dark border mr-2 text-monospace" style={{ width: "70px", display: "inline-block" }}>
                              Strip:
                            </span>
                            <img
                              src={row.stripImage || "/icons/upload_icon.svg"}
                              alt="strip preview"
                              className="rounded border pointer"
                              style={{ width: "180px", height: "30px", objectFit: "cover" }}
                            />
                          </div>
                          <div className="d-flex align-items-center mt-1">
                            <span className="badge bg-light text-dark border mr-2 text-monospace" style={{ width: "70px", display: "inline-block" }}>
                              Expanded:
                            </span>
                            <img
                              src={row.expandedImage || "/icons/upload_icon.svg"}
                              alt="expanded preview"
                              className="rounded border pointer"
                              style={{ width: "120px", height: "60px", objectFit: "cover" }}
                            />
                          </div>
                        </div>
                      ) : (
                        <img
                          src={row.image || "/icons/upload_icon.svg"}
                          alt="preview"
                          className="rounded border pointer py-1"
                          style={{ maxWidth: "160px", maxHeight: "80px", objectFit: "contain" }}
                        />
                      )}
                    </TableCell>
                    <TableCell align="left" className="td_cell align-middle font-weight-bold">
                      {row.alt || "-"}
                    </TableCell>
                    <TableCell align="left" className="td_cell align-middle text-primary">
                      <code className="text-break">{row.href || "-"}</code>
                    </TableCell>
                    <TableCell align="center" className="td_cell align-middle">
                      <div className="small">
                        <span className="text-success font-weight-bold">Start:</span>{" "}
                        {row.startDate ? moment(row.startDate).format("DD MMM YYYY, HH:mm") : "-"}
                      </div>
                      <div className="small mt-1">
                        <span className="text-danger font-weight-bold">End:</span>{" "}
                        {row.endDate ? moment(row.endDate).format("DD MMM YYYY, HH:mm") : "-"}
                      </div>
                    </TableCell>
                    <TableCell align="center" className="td_cell align-middle">
                      {ablity({ model: "Ads", action: "update" }) === 1 ? (
                        <IOSSwitch
                          checked={row.isActive || false}
                          onChange={() => handleStatusToggle(row.id, row.isActive)}
                        />
                      ) : (
                        <span className={`badge ${row.isActive ? "bg-success" : "bg-danger"} text-white`}>
                          {row.isActive ? "Active" : "Inactive"}
                        </span>
                      )}
                    </TableCell>
                    <TableCell align="center" className="td_cell align-middle">
                      <div className="d-flex justify-content-center align-items-center">
                        {ablity({ model: "Ads", action: "update" }) === 1 && (
                          <IconButton
                            className="pointer px-2"
                            onClick={() => history.push(`/ads-and-banner/edit/${row.id}`)}
                          >
                            <SvgIcon src="/icons/edit_icon.svg" alt="edit icon" />
                          </IconButton>
                        )}
                        {ablity({ model: "Ads", action: "delete" }) === 1 && (
                          <IconButton
                            className="pointer px-2"
                            onClick={() => handleDeleteClick(row.id)}
                          >
                            <SvgIcon src="/icons/delete_icon.svg" alt="delete icon" />
                          </IconButton>
                        )}
                      </div>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {adsData.length > 0 && (
          <div className="d-flex justify-content-end align-items-center mt-3 pr-2">
            <Stack spacing={2}>
              <Pagination
                count={Math.ceil((adsData.length || 0) / limit)}
                shape="rounded"
                size="small"
                onChange={handlePageChange}
              />
            </Stack>
          </div>
        )}
      </div>
    </React.Fragment>
  );
}

export default AdsAndBanner;
